<template>
  <div ref="containerRef" :class="b('splash-screen')"></div>
</template>

<script src="./scripts.js" />

<style module src="./styles.scss" lang="scss" />
